import Box from "@mui/material/Box";
import { Text } from "@fluentui/react";
import * as React from "react";
import type { QuotedRate } from "@src/types/api";
import OfferCard from "./FTLOfferCard";
import CustomerOffer, { type CustomerOfferPatch } from "./CustomerOffer";
import type { ProviderBranding } from "./providerBranding";
import { readQuotedRateNumberField } from "./ftlFormModel";
import { styles } from "./FTL.styles";

export function FtlTmsOffersBlock({
  customerOfferUiKey,
  primaryTmsOffer,
  hasAnyTmsOffers,
  onCustomerOfferCommit,
  tmsSectionTitle,
  tmsBranding,
  tmsRowOffers,
  isSingleTmsOffer,
  selectedOffer,
  onSelectOffer,
  offerMargins,
  onMarginChange,
  showConfidence,
  confidenceField,
}: {
  customerOfferUiKey: number;
  primaryTmsOffer: QuotedRate | null;
  hasAnyTmsOffers: boolean;
  onCustomerOfferCommit: (patch: CustomerOfferPatch) => void;
  tmsSectionTitle: string;
  tmsBranding: ProviderBranding;
  tmsRowOffers: QuotedRate[];
  isSingleTmsOffer: boolean;
  selectedOffer: string | null;
  onSelectOffer: (offerId: string | null) => void;
  offerMargins: Record<string, number>;
  onMarginChange: (offerId: string, marginPct: number) => void;
  showConfidence: boolean;
  confidenceField: string;
}): React.ReactElement {
  return (
    <>
      <CustomerOffer
        key={customerOfferUiKey}
        offer={primaryTmsOffer}
        enabled={Boolean(primaryTmsOffer && hasAnyTmsOffers)}
        onApply={onCustomerOfferCommit}
      />
      <Box sx={styles.offerSection}>
        <Text variant="medium" styles={styles.sectionTitle}>
          {tmsSectionTitle}
        </Text>
        <Box className="offers-grid" sx={styles.offersGrid}>
          {tmsRowOffers.map((offer) => (
            <OfferCard
              key={offer.id}
              offer={offer}
              selectOffer={onSelectOffer}
              selectedOffer={selectedOffer}
              selectionLocked={isSingleTmsOffer}
              cardTitle={tmsSectionTitle}
              logoSrc={tmsBranding.logoSrc}
              logoAlt={tmsBranding.logoAlt}
              logoHeight={tmsBranding.logoHeight}
              hideMarginControls
              showTmsCostBreakdown
              marginPct={offerMargins[offer.id] ?? offer.marginPct ?? 0}
              onMarginChange={(marginPct) => onMarginChange(offer.id, marginPct)}
              isBestRate={false}
              showConfidence={showConfidence}
              confidenceValue={readQuotedRateNumberField(offer, confidenceField)}
            />
          ))}
          {tmsRowOffers.length === 0 && (
            <Text styles={styles.emptySectionText}>No TMS offers yet.</Text>
          )}
        </Box>
      </Box>
    </>
  );
}
